import { Configuration } from '@azure/msal-browser';
import type { SystemConfig } from './serverConfig';

/**
 * Creates MSAL configuration from system config.
 *
 * OAuth `redirectUri` targets the MSAL v5 redirect bridge (`/redirect` under the app's public URL).
 * Register that bridge URL explicitly in Entra ID (SPA redirect URIs); it differs from post-logout URLs.
 */
export function getMsalConfig(systemConfig: SystemConfig): Configuration {
  if (
    !systemConfig.msalConfig?.redirectUri ||
    !systemConfig.msalConfig?.instance ||
    !systemConfig.msalConfig?.tenantId ||
    !systemConfig.msalConfig?.clientId ||
    !systemConfig.msalConfig?.scope
  ) {
    throw new Error('MSAL configuration is missing or incomplete in systemConfig');
  }

  const callbackBaseUrl = (systemConfig.msalConfig.redirectUri + systemConfig.basePath).replace('//', '/');
  const oauthRedirectUri = callbackBaseUrl.endsWith('/') ? `${callbackBaseUrl}redirect` : `${callbackBaseUrl}/redirect`;

  return {
    auth: {
      clientId: systemConfig.msalConfig.clientId,
      authority: `${systemConfig.msalConfig.instance}${systemConfig.msalConfig.tenantId}`,
      redirectUri: oauthRedirectUri,
      postLogoutRedirectUri: callbackBaseUrl,
    },
    cache: {
      cacheLocation: 'localStorage',
    },
    system: {
      allowRedirectInIframe: true,
      popupBridgeTimeout: 60000,
      iframeBridgeTimeout: 6000,
    },
  };
}
